import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { type CreateSiteViaCSVResponse } from './types';
import { zodCreateSiteViaCSVResponseSchema } from './validations';

/**
 * Creates sites from a CSV file.
 *
 * @param file - The CSV file with one site per row.
 * @param options - Additional options for the request (e.g., abort signal).
 * @returns The ids of the created sites and the server's message.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Site/operation/import_sites_from_csv_site_import_csv_post
 */
export const createSiteViaCSV = async (
  file: File,
  options?: KyRequestOptions,
) => {
  const formData = new FormData();
  formData.append('data', file);

  return await vestigasApi
    .post(ENDPOINT.SITE.CREATE_VIA_CSV(), {
      ...options,
      body: formData,
      validate: {
        ...options?.validate,
        response: zodCreateSiteViaCSVResponseSchema,
      },
    })
    .json<CreateSiteViaCSVResponse>();
};
